import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Dashboard
export const getDashboard = () => axios.get(`${API_URL}/dashboard`);

// Auth
export const login = (email, password) => axios.post(`${API_URL}/auth/login`, { email, password });
export const register = (name, email, password) => axios.post(`${API_URL}/auth/register`, { name, email, password });
export const inviteUser = (data) => axios.post(`${API_URL}/auth/invite`, data);
export const listUsers = () => axios.get(`${API_URL}/auth/users`);
export const updateUserRole = (userId, role) => axios.put(`${API_URL}/auth/users/${userId}/role?role=${role}`);

// Entities
export const getLegalEntities = () => axios.get(`${API_URL}/entities/legal`);
export const createLegalEntity = (data) => axios.post(`${API_URL}/entities/legal`, data);
export const deleteLegalEntity = (id) => axios.delete(`${API_URL}/entities/legal/${id}`);

export const getOperatingEntities = () => axios.get(`${API_URL}/entities/operating`);
export const createOperatingEntity = (data) => axios.post(`${API_URL}/entities/operating`, data);
export const deleteOperatingEntity = (id) => axios.delete(`${API_URL}/entities/operating/${id}`);

// Threads
export const getThreads = (params) => axios.get(`${API_URL}/threads`, { params });
export const getThread = (id) => axios.get(`${API_URL}/threads/${id}`);
export const getThreadFull = (id) => axios.get(`${API_URL}/threads/${id}/full`);
export const createThread = (data) => axios.post(`${API_URL}/threads`, data);
export const updateThread = (id, data) => axios.put(`${API_URL}/threads/${id}`, data);
export const deleteThread = (id) => axios.delete(`${API_URL}/threads/${id}`);

// Evidence
export const getEvidenceRecords = (params) => axios.get(`${API_URL}/evidence`, { params });
export const getEvidenceRecord = (id) => axios.get(`${API_URL}/evidence/${id}`);
export const verifyEvidence = (id) => axios.get(`${API_URL}/evidence/verify/${id}`);

// Intake
export const processIntake = (data) => axios.post(`${API_URL}/intake`, data);
export const uploadTranscript = (formData) => axios.post(`${API_URL}/intake/upload`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

// Funnels
export const getFunnelItems = (params) => axios.get(`${API_URL}/funnels`, { params });
export const getStalledFunnels = () => axios.get(`${API_URL}/funnels/stalled`);
export const createFunnelItem = (data) => axios.post(`${API_URL}/funnels`, data);
export const updateFunnelItem = (id, data) => axios.put(`${API_URL}/funnels/${id}`, data);
export const deleteFunnelItem = (id) => axios.delete(`${API_URL}/funnels/${id}`);
export const getFunnelStats = () => axios.get(`${API_URL}/funnels/stats/by-type`);

// Deals
export const getDeals = (params) => axios.get(`${API_URL}/deals`, { params });
export const getDeal = (id) => axios.get(`${API_URL}/deals/${id}`);
export const createDeal = (data) => axios.post(`${API_URL}/deals`, data);
export const updateDeal = (id, data) => axios.put(`${API_URL}/deals/${id}`, data);
export const deleteDeal = (id) => axios.delete(`${API_URL}/deals/${id}`);

// Vehicles
export const getVehicles = (params) => axios.get(`${API_URL}/vehicles`, { params });
export const getVehicle = (id) => axios.get(`${API_URL}/vehicles/${id}`);
export const createVehicle = (data) => axios.post(`${API_URL}/vehicles`, data);
export const updateVehicle = (id, data) => axios.put(`${API_URL}/vehicles/${id}`, data);
export const deleteVehicle = (id) => axios.delete(`${API_URL}/vehicles/${id}`);

// Actions
export const getActionItems = (params) => axios.get(`${API_URL}/actions`, { params });
export const getOverdueActions = () => axios.get(`${API_URL}/actions/overdue`);
export const createActionItem = (data) => axios.post(`${API_URL}/actions`, data);
export const updateActionItem = (id, data) => axios.put(`${API_URL}/actions/${id}`, data);
export const updateActionStatus = (id, status) => axios.put(`${API_URL}/actions/${id}/status?status=${status}`);
export const deleteActionItem = (id) => axios.delete(`${API_URL}/actions/${id}`);

// Drafts
export const getDraftMessages = (params) => axios.get(`${API_URL}/drafts`, { params });
export const getPendingDrafts = () => axios.get(`${API_URL}/drafts/pending`);
export const createDraftMessage = (data) => axios.post(`${API_URL}/drafts`, data);
export const approveDraft = (id) => axios.put(`${API_URL}/drafts/${id}/approve`);
export const rejectDraft = (id) => axios.put(`${API_URL}/drafts/${id}/reject`);
export const markDraftSent = (id) => axios.put(`${API_URL}/drafts/${id}/send`);
export const deleteDraft = (id) => axios.delete(`${API_URL}/drafts/${id}`);

// Strategy
export const getStrategyBriefs = (params) => axios.get(`${API_URL}/strategy`, { params });
export const generateStrategyBrief = (threadId) => axios.post(`${API_URL}/strategy/generate`, { related_thread_id: threadId });
export const getStrategyBrief = (id) => axios.get(`${API_URL}/strategy/${id}`);
export const updateBriefStatus = (id, status) => axios.put(`${API_URL}/strategy/${id}/status?status=${status}`);
export const exportBriefForChatGPT = (id) => axios.get(`${API_URL}/strategy/${id}/export`);
export const getStrategyPrompt = (threadId) => axios.get(`${API_URL}/strategy/thread/${threadId}/prompt`);
export const deleteStrategyBrief = (id) => axios.delete(`${API_URL}/strategy/${id}`);

// Tests
export const runAllTests = () => axios.get(`${API_URL}/tests/run`);

// Seed
export const seedData = () => axios.post(`${API_URL}/seed`);

// Calendar Integration
export const getCalendarStatus = () => axios.get(`${API_URL}/calendar/status`);
export const getCalendarAuthUrl = () => axios.get(`${API_URL}/calendar/auth/url`);
export const disconnectCalendar = () => axios.post(`${API_URL}/calendar/disconnect`);
export const getCalendarEvents = (daysAhead = 7) => axios.get(`${API_URL}/calendar/events?days_ahead=${daysAhead}`);
export const getUpcomingBookedTime = (hoursAhead = 48) => axios.get(`${API_URL}/calendar/upcoming?hours_ahead=${hoursAhead}`);
export const syncCalendarToEvidence = (daysBack = 1) => axios.post(`${API_URL}/calendar/sync?days_back=${daysBack}`);

// Outbound Communications
export const sendEmail = (draftId) => axios.post(`${API_URL}/outbound/send/email`, { draft_id: draftId, confirm_send: true });
export const getWhatsAppDeepLink = (draftId) => axios.get(`${API_URL}/outbound/deeplink/whatsapp/${draftId}`);
export const getLinkedInDeepLink = (draftId) => axios.get(`${API_URL}/outbound/deeplink/linkedin/${draftId}`);
export const confirmManualSend = (draftId, channel) => axios.post(`${API_URL}/outbound/confirm-sent/${draftId}?channel=${channel}`);
export const getOutboundStatus = (draftId) => axios.get(`${API_URL}/outbound/status/${draftId}`);

// Intake Events (Tier-1)
export const createIntakeEvent = (data) => axios.post(`${API_URL}/intake-events`, data);
export const getIntakeEvents = (params) => axios.get(`${API_URL}/intake-events`, { params });
export const getPendingIntakeEvents = () => axios.get(`${API_URL}/intake-events/pending`);
export const getIntakeEvent = (id) => axios.get(`${API_URL}/intake-events/${id}`);
export const confirmIntakeEvent = (id, data) => axios.post(`${API_URL}/intake-events/${id}/confirm`, data);
export const rejectIntakeEvent = (id, reason) => axios.post(`${API_URL}/intake-events/${id}/reject?reason=${encodeURIComponent(reason || '')}`);
export const deleteIntakeEvent = (id) => axios.delete(`${API_URL}/intake-events/${id}`);

// Business Memory (Tier-1)
export const getExecutiveSummary = (date) => axios.get(`${API_URL}/memory/executive-summary${date ? `?date=${date}` : ''}`);
export const getFinancialEvents = (params) => axios.get(`${API_URL}/memory/financial`, { params });
export const getCampaignSignals = (params) => axios.get(`${API_URL}/memory/campaign`, { params });
export const getNarrativeSignals = (params) => axios.get(`${API_URL}/memory/narrative`, { params });

// Whisper Transcription
export const transcribeAudio = (audioBlob) => {
  const formData = new FormData();
  formData.append('file', audioBlob, 'recording.webm');
  return axios.post(`${API_URL}/intake/transcribe`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Threads (for intake)
export const getThreadsSimple = () => axios.get(`${API_URL}/threads?limit=100`);
